import NetworkLogic from "../../Shared/NetworkLogic";
import UIManager from "../../Shared/UIManager";
import AudioManager from "../../Shared/AudioManager";
import { Global } from "../../Shared/Global";
import TaskData from "./TaskData";
import ActivityAndTask from "../Activity/ActivityAndTask";
import Utils from "../../Shared/Utils";
import Constant from "../../Shared/Constant";
import TuiGuangLayer from "../TuiGuang/TuiGuangLayer";
import Player from "../../Models/Player";
import HallUI from "../HallUI";
const i18n = require('LanguageData');

const { ccclass, property } = cc._decorator;

@ccclass
export default class TaskShare extends cc.Component {
    @property(cc.Node)
    gunPing0: cc.Node = null;
    @property(cc.Node)
    gunPing1: cc.Node = null;
    @property([cc.Node])
    gunPingArr: cc.Node[] = [];
    @property(cc.Sprite)
    spShare: cc.Sprite = null;
    @property(cc.Sprite)
    spAgent: cc.Sprite = null;


    shareData = null;
    rankIndex = 0;
    private pos0: cc.Vec2;
    private pos1: cc.Vec2;

    index = 0;
    private rankingList = [];
    private bscroll: boolean = false;

    speed = 1;
    /***
     * shareTaskSet:
     auditMoney: 1
     descText: "aDASD"
     shareDesc: "http://api.fanyirong.com:8080/group1/zonghe/4f855e4d9a749151397ccaf5c3633e98.jpg"
     shareImg: Array(6)
     0: "http://api.fanyirong.com:8080/group1/zonghe/4f855e4d9a749151397ccaf5c3633e98.jpg"
     1: "http://api.fanyirong.com:8080/group1/zonghe/4f855e4d9a749151397ccaf5c3633e98.jpg"
     2: "http://api.fanyirong.com:8080/group1/zonghe/4f855e4d9a749151397ccaf5c3633e98.jpg"
     3: "http://api.fanyirong.com:8080/group1/zonghe/4f855e4d9a749151397ccaf5c3633e98.jpg"
     4: "http://api.fanyirong.com:8080/group1/zonghe/4f855e4d9a749151397ccaf5c3633e98.jpg"
     5: "http://api.fanyirong.com:8080/group1/zonghe/4f855e4d9a749151397ccaf5c3633e98.jpg"
     length: 6
     __proto__: Array(0)
     shareMoney: 10
     shareSwitch: "0"
     shareText: "321312312,2321312,213123"
     shareTutorial: "<p>312321</p>"
     taskHandleStatus: ""
     uploadImgTutorial: "<p>13221312</p>"
     __proto__: Object
     shareTaskSetAgent:
     agentRecruitmentDesc: "http://api.fanyirong.com:8080/group1/zonghe/4f855e4d9a749151397ccaf5c3633e98.jpg"
     agentTutorialList: Array(2)
     0:
     titleContent: "<p>111</p>"
     titleImg: "http://api.fanyirong.com:8080/group1/zonghe/4f855e4d9a749151397ccaf5c3633e98.jpg"
     __proto__: Object
     1:
     titleContent: "<p>222</p>"
     titleImg: "http://api.fanyirong.com:8080/group1/zonghe/db86a49e47f97f9dba3e76e607afcb69.png"
     __proto__: Object
     length: 2
     __proto__: Array(0)
     shareSwitch: "0"
     */

    onLoad(): void {
    }



    start() {
        cc.director.on(Global.UserEvent.UpdateShareRedPoint, this.updateShareRedPoint, this)
        cc.director.on(Global.UserEvent.UpdateShareTaskBtn, this.updateBtn, this)
        this.pos0 = this.gunPing0.position;
        this.pos1 = this.gunPing1.position;

    }
    onDestroy(): void {
        this.unscheduleAllCallbacks();
        cc.director.off(Global.UserEvent.UpdateShareRedPoint, this.updateShareRedPoint, this)
        cc.director.off(Global.UserEvent.UpdateShareTaskBtn, this.updateBtn, this)
    }

    updateShareRedPoint() {
        let storageCopy = cc.sys.localStorage.getItem(Global.localStorageId.TaskCopy + Player.getPy("userID"));
        let storageSave = cc.sys.localStorage.getItem(Global.localStorageId.TaskSave + Player.getPy("userID"));
        let storageShare = cc.sys.localStorage.getItem(Global.localStorageId.TaskShare + Player.getPy("userID"));
        let storageSubmit = cc.sys.localStorage.getItem(Global.localStorageId.TaskSubmit + Player.getPy("userID"));
        let date = new Date();
        if (!storageCopy || storageCopy != "copy" + Player.getPy("userID") ||
            !storageSave || storageSave != "save" + Player.getPy("userID") ||
            !storageShare || storageShare != "share" + Player.getPy("userID") ||
            !storageSubmit || storageSubmit !== date.getUTCDate().toString() + Player.getPy("userID")
        ) {
            this.spShare.node.getChildByName("redPoint").active = true;
        } else {
            this.spShare.node.getChildByName("redPoint").active = false;
        }
    }

    async updateBtn() {//提交审核之后需要更新状态
        this.shareData = await TaskData._getTaskList(8);
    }

    async updateUI(param) {

        let index = parseInt(param);
        if (!this.shareData) {
            this.shareData = await TaskData._getTaskList(index);
        }
        if (!this.shareData) return ;
        this.rankingList = this.shareData.rankingList;
        this.rankingList.length > 0 && this.setScrollData(this.rankingList)
        let shareTaskSet = this.shareData.shareTaskSet;

        if (!shareTaskSet) {
            this.spShare.node.active = false;
        } else {
            let storageCopy = cc.sys.localStorage.getItem(Global.localStorageId.TaskCopy + Player.getPy("userID"));
            let storageSave = cc.sys.localStorage.getItem(Global.localStorageId.TaskSave + Player.getPy("userID"));
            let storageShare = cc.sys.localStorage.getItem(Global.localStorageId.TaskShare + Player.getPy("userID"));
            let storageSubmit = cc.sys.localStorage.getItem(Global.localStorageId.TaskSubmit + Player.getPy("userID"));
            let date = new Date();
            if (!storageCopy || storageCopy != "copy" + Player.getPy("userID") ||
                !storageSave || storageSave != "save" + Player.getPy("userID") ||
                !storageShare || storageShare != "share" + Player.getPy("userID") ||
                !storageSubmit || storageSubmit !== date.getUTCDate().toString() + Player.getPy("userID")
            ) {
                this.spShare.node.getChildByName("redPoint").active = true;
            }

            cc.loader.load(shareTaskSet.shareDesc, function (err, texture) {
                if (!err && this.node) {
                    if (cc.isValid(this.spShare)) {
                        this.spShare.node.getChildByName("logo").active = false;
                        this.spShare.spriteFrame = new cc.SpriteFrame(texture);
                    }
                } else {
                    cc.log("===加载图片spShare错误");
                }
            }.bind(this));
        }

        cc.loader.load(shareTaskSet.agentRecruitmentDesc, function (err, texture) {
            if (!err && this.node) {
                if (cc.isValid(this.spAgent)){
                    this.spAgent.node.getChildByName("logo").active = false;
                    this.spAgent.spriteFrame = new cc.SpriteFrame(texture);
                }
            }else {
                cc.log("===加载图片spAgent错误");
            }
        }.bind(this))

    }

    setScrollData(rankingList) {
        if (this.rankingList.length <= 0) {
            return;
        }
        for (let i = 0; i < this.gunPing0.children.length; i++) {
            let richText = this.gunPing0.children[i].getComponent(cc.RichText);
            richText.string = this._getStr(rankingList[this.rankIndex]);
            this.rankIndex++;
            this.rankIndex %= rankingList.length
        }
        for (let i = 0; i < this.gunPing1.children.length; i++) {
            let richText = this.gunPing1.children[i].getComponent(cc.RichText);
            richText.string = this._getStr(rankingList[this.rankIndex]);
            this.rankIndex++;
            this.rankIndex %= rankingList.length
        }
        this.bscroll = true;
    };

    rankListScroll() {

        let seq = cc.repeatForever(
            cc.sequence(
                cc.moveBy(7, cc.v2(0, 361.6)),
                cc.callFunc(function () {
                    //if (this.index%2 === 1){
                    this.gunPing0.position = this.pos1;
                    for (let i = 0; i < this.gunPing0.children.length; i++) {
                        let richText = this.gunPing0.children[i].getComponent(cc.RichText);
                        richText.string = this._getStr(this.rankingList[this.rankIndex]);
                        this.rankIndex++;
                        this.rankIndex %= this.rankingList.length
                    }
                    //}
                }.bind(this))
            )
        );

        let seq1 = cc.repeatForever(
            cc.sequence(
                cc.moveBy(7, cc.v2(0, 361.6)),
                cc.callFunc(function () {
                    //if (this.index%2 === 1){
                    this.gunPing1.position = this.pos1;
                    for (let i = 0; i < this.gunPing0.children.length; i++) {
                        let richText = this.gunPing0.children[i].getComponent(cc.RichText);
                        richText.string = this._getStr(this.rankingList[this.rankIndex]);
                        this.rankIndex++;
                        this.rankIndex %= this.rankingList.length
                    }
                    //}
                }.bind(this))
            )
        );
        this.gunPing0.runAction(seq);
        this.scheduleOnce(function () {
            this.gunPing1.runAction(seq1);
        }.bind(this), 4)

    }

    update(dt: number): void {
        if (!this.bscroll) return;
        if (this.rankingList.length <= 0) {
            return;
        }
        for (let i = 0; i < this.gunPingArr.length; i++) {
            let node = this.gunPingArr[i];
            node.position = cc.v2(node.position.x, node.position.y + this.speed);
            // cc.log("===nodeName:%s,node.position:(%s,%s)",node.name,node.position.x,node.position.y);
            if (node.position.y >= 281.6) {
                node.position = cc.v2(node.position.x, -121.6);
                //cc.log("===进入条件nodeName:%s,node.position:(%s,%s)",node.name,node.position.x,node.position.y);
                for (let j = 0; j < node.children.length; j++) {
                    let richText = node.children[j].getComponent(cc.RichText);
                    richText.string = this._getStr(this.rankingList[this.rankIndex]);
                    this.rankIndex++;
                    this.rankIndex %= this.rankingList.length
                }
            }
        }
    }

    _getStr(data) {
        let str = ""
        if (data.type === 1) {
            str = `<color =#FFEB00>${data.userId}</color>${i18n.t('XimaLayer.receive')}<color =#0fffff>${i18n.t('TuiGuangLayer.agent_commission')}</color><color =#FF0000>${data.brokerageMoney}</color>${i18n.t('baes_text.coin')}`
        } else if (data.type === 2) {
            str = `<color =#FFEB00>${data.userId}</color>${i18n.t('XimaLayer.receive')}<color =#0fffff>${i18n.t('TuiGuangLayer.share_commission')}</color><color =#FF0000>${data.shareBonusMoney}</color>${i18n.t('baes_text.coin')}`
        }
        return str;
    }

    onBtnClick(event, param) {
        AudioManager.playSound("button");
        let tastNode = this.node.parent;
        let allActivity: ActivityAndTask = tastNode.parent.parent.getComponent("ActivityAndTask")
        if (!Player.isLogedIn()) {
            let hallUI: HallUI = cc.find("Canvas/gameNode") && cc.find("Canvas/gameNode").getComponent(HallUI)
            hallUI.checkLoginAndShowUI();
            allActivity.onBtnClose();
            return;
        }
        if (param === "share") {
            if (this.shareData.shareTaskSet.shareSwitch != "0") {
                UIManager.showToastUI(i18n.t('Task.task_ShutDown'));
                return;
            }
            //调分享的预制体
            let share = allActivity.openChildUI(allActivity.pfbShare,);
            share.getComponent("TaskShareClick").updateUI(this.shareData.shareTaskSet);
        } else if (param === "agent") {
            let hallUI: HallUI = cc.find("Canvas/gameNode").getComponent("HallUI");
            let tuiguang = hallUI.openChildUI(hallUI.pfbTuiGuang).getComponent("TuiGuangLayer");
            tuiguang.updateUI("agentRecruit")
        }

    }

}
